<template>
  <!--创建合同(演示页面)-->
  <el-container class="to-create">
    <template v-if="!nextstep">
      <!--左侧-->
      <el-aside
        width="2.80rem"
        class="aside-left"
        :style="{ height: boxHeight }"
      >
        <p class="page-total">
          共{{
            fileList.length > 0
              ? `${fileList.length}个文件`
              : `${contractInfo.items}页`
          }}
        </p>
        <div>
          <!-- 上传文件后合同列表 -->
          <div class="page-con" v-if="fileList.length > 0">
            <template v-for="(file, i) in fileList">
              <div :key="i" @click="chooseFile(file, i)" class="list">
                <el-tooltip effect="light" placement="right-start">
                  <div slot="content">此文件设置有签署位置</div>
                  <i v-show="filePage(file)" class="icon icon-status_sign"></i>
                </el-tooltip>
                <div class="bx" :class="checkAct === i ? 'active' : ''">
                  <div>
                    <img
                      v-if="fileSuffix(file.fileName || file.name) === 'pdf'"
                      src="/images/advancedVersion/pdf.png"
                    />
                    <img
                      v-if="fileSuffix(file.fileName || file.name) === 'wps'"
                      src="/images/advancedVersion/WPS.png"
                    />
                    <img
                      v-if="fileSuffix(file.fileName || file.name) === 'jpg'"
                      src="/images/advancedVersion/JPG.png"
                    />
                    <img
                      v-if="
                        fileSuffix(file.fileName || file.name) === 'doc' ||
                        fileSuffix(file.fileName || file.name) === 'docx'
                      "
                      src="/images/advancedVersion/word.png"
                    />
                    <img
                      v-if="
                        fileSuffix(file.fileName || file.name) === 'xlsx' ||
                        fileSuffix(file.fileName || file.name) === 'xls'
                      "
                      src="/images/advancedVersion/xlsx.png"
                    />
                  </div>
                </div>
                <p class="title" :title="file.fileName">
                  {{ file.fileName || file.name }}
                </p>
              </div>
            </template>
          </div>
          <!-- 默认模板合同列表 -->
          <div class="page-con" v-else>
            <template v-for="i in contractInfo.items">
              <div
                @click="getContractDetailByNum(i)"
                :key="i"
                :class="currentInfo.page === i ? 'active' : ''"
                class="list"
              >
                <img v-if="contractList[i]" :src="contractList[i].url" />
                <img v-else src="/images/contr_default.jpg" alt="" />
                <span>{{ i }}</span>
              </div>
            </template>
          </div>
        </div>
        <!-- <div class="go-Page">
          <div>
            <div>
              <div class="bd">
                <el-input
                  v-model="goPageNum"
                  placeholder="输入页码"
                  type="number"
                  @keyup.enter.native="handleContractPageClick"
                />
                /{{ contractInfo.items }}
              </div>
              <a @click="handleContractPageClick">GO</a>
            </div>
          </div>
        </div> -->
      </el-aside>
      <!--合同显示详情-->
      <el-main class="main-content" :style="{ height: boxHeight }">
        <contract-view
          v-if="fileList.length == 0"
          ref="contractView"
          :contract-info.sync="currentInfo"
          :chapter-list.sync="chapteJson"
          :items="contractInfo.items"
          :page="currentInfo.page"
          :scaleValue.sync="scaleValue"
          :show-chapter="true"
          @del-chapte="delChapteByCindex($event)"
          @pre-page="getContractDetailByNum($event)"
          @next-page="getContractDetailByNum($event)"
          @changeSmallMap="changeSmallMap"
          @toCurrentPage="toCurrentPage"
        />
        <!-- 文件展示 -->
        <contract-view-file
          v-else
          ref="contractView"
          :contract-info.sync="currentInfo"
          :chapter-list.sync="chapteJson"
          :items="contractInfoTemporary.items"
          :page="currentInfo.page"
          :scaleValue.sync="scaleValue"
          :targetId="contractInfoTemporary.targetId"
          :show-chapter="true"
          @del-chapte="delChapteByCindex($event)"
          :signatory-json="signatoryJson"
          @pre-page="getContractDetailByNum($event)"
          @next-page="getContractDetailByNum($event)"
          @changeSmallMap="changeSmallMap"
          @toCurrentPage="toCurrentPage"
        />
        <!--添加附件-->
        <div ref="accessory" class="text-center accessory-box">
          <!-- 去顶部去底部按钮 -->
          <template
            v-if="contractInfo && contractInfo.items && contractInfo.items > 1"
          >
            <span class="jumpFirst" @click="goPageAndFixed(1)"
              ><img src="../../assets/images/btn-down.png"
            /></span>
            <span
              class="jumpLast"
              @click="
                goPageAndFixed(
                  fileList.length == 0
                    ? contractInfo.items
                    : contractInfoTemporary.items
                )
              "
              ><img src="../../assets/images/btn-down.png"
            /></span>
          </template>
        </div>
      </el-main>
      <!--右侧-->
      <el-aside
        width="2.80rem"
        class="aside-right"
        :style="{ height: boxHeight }"
      >
        <div class="qs-wrap">
          <p class="m-title">&nbsp;&nbsp;上传文件</p>
          <div class="qs-box">
            <el-upload
              action="#"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.wps"
              multiple
              :limit="30"
              :before-upload="fileOnBeforeUpload"
              :on-exceed="fileHandleExceed"
              :on-error="fileOnError"
              :show-file-list="false"
              style="padding: 0 25px"
            >
              <slot>
                <div class="upload-content">
                  <!-- <span class="el-icon-plus"></span> -->
                  <el-button class="btn danger-btn mybtn">点击上传</el-button>
                  <p class="el-upload__tip t3">
                    上传 pdf、doc、docx、xls、xlsx 、wps格式文件
                  </p>
                </div>
              </slot>
            </el-upload>
          </div>
        </div>

        <!--签署方列表-->
        <!-- <div class="list-signers" :style="{maxHeight: listHeight}"> -->
        <div class="list-signers">
          <p class="t2">&nbsp;&nbsp;设置签章位置</p>
          <p class="t3">在签署页，拖动签章位置到需要盖章的地方</p>
          <div class="qy-wrap">
            <template v-if="signatoryJson">
              <div v-for="(item, index) in signatoryJson" :key="index">
                <!-- 批量签署方 -->
                <template v-if="item.signOwner === '批量签署方'">
                  <div :key="item.signOwner" style="margin-top: 18px">
                    <p class="user-show">
                      <i
                        @click="delSignList(item)"
                        class="el-icon-error del-signer"
                      ></i>
                    </p>
                    <div class="row-wrap">
                      <div
                        class="dragbox"
                        draggable="true"
                        @dragend="dragQZEnd($event, item.signOwner)"
                      >
                        <el-button
                          draggable="true"
                          @click="handleAddChapter(item.signOwner)"
                          size="small"
                          title="点击或拖拽"
                          class="normal-btn"
                        >
                          <span class="rt" style="width: 90px">批量签署方</span
                          >{{ item.signOwner }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 普通签署方 -->
                <template v-else>
                  <el-button-group :key="item.signOwner" class="btn-group">
                    <!-- 公司签章名称 -->
                    <p class="user-show">
                      <span
                        v-if="item.signatoryFullName"
                        :title="item.signatoryFullName"
                        class="font-ellipsis"
                        >{{ item.signatoryFullName }}</span
                      >
                    </p>
                    <!-- 设置签章位置按钮 -->
                    <div class="row-wrap">
                      <div
                        class="dragbox"
                        draggable="true"
                        @dragend="
                          dragQZEnd(
                            $event,
                            item.signOwner,
                            item.signatoryFullName
                          )
                        "
                      >
                        <el-button
                          @click="
                            handleAddChapter(
                              item.signOwner,
                              item.signatoryFullName
                            )
                          "
                          size="small"
                          draggable="true"
                          type="danger"
                          class="normal-btn"
                          ref="step3"
                          title="点击或拖拽"
                          ><span class="rt">{{ item.signOwner }}</span
                          >设置签章位置
                        </el-button>
                      </div>
                    </div>
                  </el-button-group>
                </template>
              </div>
            </template>

            <!--              <p style="color: #999;font-size: 12px;padding-right: 20px;margin-top:40px;">1、点击“添加签署方”，可增加签署方。</p>-->
            <!--              <p style="color: #999;font-size: 12px;padding-right: 20px">2、翻动到需要签章的文件页，点击对应签署方，可拖动限定该方的签署位置。</p>-->
          </div>
          <!-- 位置信息 -->
          <div>
            <p class="t2">&nbsp;&nbsp;位置信息</p>
            <el-card
              v-for="(item, i) of chapteJson"
              :key="i"
              style="margin-bottom: 10px"
            >
              <div slot="header" class="clearfix">
                <span style="font-weight: bold">{{ item.signOwner }}</span>
                <span
                  style="float: right; padding: 3px 0; font-size: 12px"
                  type="text"
                  >{{ `在第 ${item.page + 1} 页` }}</span
                >
              </div>
              <div>
                {{ "X坐标 " + item.offsetX }}
              </div>
              <div>
                {{ "Y坐标 " + item.offsetY }}
              </div>
            </el-card>
          </div>
        </div>
      </el-aside>
    </template>

    <!--签署指引-->
    <div v-if="guideStep" class="apply-guide">
      <div class="box" ref="guideBox">
        <div
          v-if="guideStep !== 'step5'"
          class="tooltip"
          :class="guideStep === 'step4' ? 'tooltip-top' : 'tooltip-bottom'"
          ref="tooltip"
        >
          <template v-if="guideStep === 'step1'">
            <div class="tooltip-text"><span>1</span>点击添加签署方</div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)"
                >关闭引导</a
              >
              <a @click="guideApply('step2')" href="javascript:void (0)"
                >下一步</a
              >
            </div>
            <div class="tooltip-arrow" style="left: 65%"></div>
          </template>
          <template v-if="guideStep === 'step2'">
            <div class="tooltip-text"><span>2</span>点击填写签署方信息</div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)"
                >关闭引导</a
              >
              <a @click="guideApply('step3')" href="javascript:void (0)"
                >下一步</a
              >
            </div>
            <div class="tooltip-arrow" style="left: 92%"></div>
          </template>
          <template v-if="guideStep === 'step3'">
            <div class="tooltip-text">
              <span>3</span>点击签署方设置固定签章位置
            </div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)"
                >关闭引导</a
              >
              <a @click="guideApply('step4')" href="javascript:void (0)"
                >下一步</a
              >
            </div>
            <div class="tooltip-arrow" style="left: 75%">+</div>
          </template>
          <template v-if="guideStep === 'step4'">
            <div class="tooltip-text"><span>4</span>点击添加附件</div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)">完成</a>
            </div>
            <div class="tooltip-arrow" style="left: 25%"></div>
          </template>
        </div>
        <template v-if="guideStep === 'step5'">
          <div
            class="tooltip tooltip-bottom"
            style="left: 10px; top: 60px"
            ref="tooltip"
          >
            <div class="tooltip-text">
              <span>1</span>顺序签名选择，可以拖动签署方进行签名排序
            </div>
            <div class="tooltiop-btns">
              <a @click="guideApplyCancel" href="javascript:void (0)">完成</a>
            </div>
            <div class="tooltip-arrow" style="left: 25%"></div>
          </div>
        </template>
      </div>
    </div>
  </el-container>
</template>

<script>
import Flow from "../../components/flow";
import draggable from "vuedraggable";
import SingerForm from "../../components/singer-form";
import ToolTip from "../../components/tool-tip";
import ContractView from "../../components/contract-view/indexOld";
import ContractViewFile from "../../components/contract-view/index";
import SignInfoTipsDialog from "../../components/contract/signInfoTipsDialog";
import {
  postCreateApply,
  postFindByEmailOrMphon,
  convertDetailToShow,
  postTelFindByPagedEnterpriseList,
  postFileTempUpload,
  getDraftInfoByApplyId,
  tempConvertToContract,
  ApiMethods,
  configUrl,
  queryCreditCodeByEntName,
  queryUserValidateByNameIDnum,
  getCorpDraftInfoByApplyId,
  uploadFileAndConvertInfo
} from "../../assets/js/http-serve/http-methods";
import {
  mobileOrEmail,
  identityNo,
  businessVal,
  personalName,
  mobile,
  happy
} from "../../assets/js/lib/valid-methods";
import VideoSign from "../../assets/js/http-serve/video-sign";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
// import TemplateManage from '../console/template';
import moment from "moment";
export default {
  data () {
    return {
      // 临时展示合同信息
      contractInfoTemporary: {},
      fileImgName: "",
      checkAct: -1, // 当前显示合同选中文件
      fileList: [], // 要上传的文件
      isError: true, // 解决 el-form-item :error 数据显示 bug
      isSaveDisable: true, //禁用保存按钮
      goPageNum: null, // 前往多少页
      payInfoData: {},
      showMoreSet: false,
      // 雷云风新的需求，发起审批新流程
      flows: [],
      hasApplyApproval: false,
      approvalFlowList: [],
      approvalFlowSelect: undefined,
      // 批量签署方 array
      batchArray: [],
      // 批量签署方 checkbox
      checkedBatch: false,
      // 支付方式select 展开关闭状态
      visibleChangeSelectStatus: false,
      // 是否是集团账户
      isGroup: false,
      // 添加审批人/抄送人Dialog
      visibleAuditAndCopy: false,
      auditAndCopyTitle: "",
      auditAndCopyActive: false,
      auditAndCopyModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0
      },
      tableListAuditAndCopy: [], // 审批人 抄送人列表

      arrayCopior: [], // 抄送人数组
      tableAuditAndCopySelectRow: undefined,
      // 我的组织 选择签署人
      myCorpModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0,
        corpUserName: "", // 名称
        corpGroupId: "" // 部门ID
      },
      tableListMyCorp: [],
      tableSignorSelectRow: undefined,
      tableSignorSelectRowTargetID: undefined,

      // 签署方 tabs
      activeTabSigner: "default", // 我的通讯录 default , 我的组织 organization
      activeTabOrganizationName: "我的组织",
      // select index
      selectIndex: 0,
      apiMethods: ApiMethods,
      // 合同信息
      contractInfo: {
        contractName: "",
        serverCa: 1,
        needCa: 0,
        signatoryJson: "[]",
        attatchFileNamesJson: "[]",
        overDate: "",
        needVideoSign: 0,
        ifOrder: false,
        needPresSign: 1,
        needQifengSign: 1,
        approveJson: "",
        returnURL:
          configUrl().junziqianWebOp + "/signInfo/signList?signStatus=2",
        consumMode: 0,
        saveToDraftBox: 0,
        applyId: null,
        contractId: null
      },
      // 合同列表
      contractList: {
        1: {
          fileName: "1.png",
          page: 1,
          url: require("@/static/images/zj/demo1.png"),
          width: 1000,
          height: 1416
        },
        2: {
          fileName: "2.png",
          page: 2,
          url: require("@/static/images/zj/demo2.png")
        }
      },
      // 附件参数信息 参数为json 现场上传{targetId: '', targetFix: '', origiName: ''}或者修改草稿箱已有的{codeName: '', origiName: ''}
      attatchFileNamesJson: [],
      signatoryJson: [
        {
          signOwner: "签署方一",
          emailOrPhone: "",
          childUserName: "",
          signatoryMobile: "",
          signatoryFullName: "",
          signatoryIdentityCard: "",
          signatoryUserType: 0,
          corpUser: false,
          //authLevel: 11,    873 需求修改，此前默认人脸认证 ，此后取消这个逻辑
          authLevel: "",
          handSign: 0,

          chapteJson: null,
          // 新增集团账户 数组
          canSelectArray: [],
          canSelectArrayIndex: 0,

          IDCard: "",
          BusinessLicenseNo: "",
          ischange: 0,
          notRegister: true,
          disabled: "",
          openUserTab: false,
          isEncrypt: false,

          isNoticePhone: false,
          showNoticePhone: false,
          alertMobile: ""
        }
      ],
      isSaveToDraftBox: false, // 合同是否保存到草稿箱
      // 企业名称和企业证件号，key(signatoryJson中的signatoryFullName签署方名称)=>value(signatoryJson中的signatoryIdentityCard证件号) 只能是企业类型的用户

      // 签署方身份信息验证相关 start
      //..... 验证用户输入的企业是否存在 start.....
      entCreditJson: null,
      entCreditArr: [],
      entNameArr: [],
      visibleCredit: false,
      //..... 验证用户输入的企业是否存在 end.....
      userIdentityInfoArr: [], // 存放需要进行姓名身份证二要素的数组
      // 签署方身份信息验证相关 end

      // 签章参数 {page: 0合同第几页, chaptes:[签章位置{offsetX: '0.5', offsetY: '0.5', cindex: 0章顺序不分甲乙方和页数, signOwner: 甲乙方, url: 章地址， page: 0合同页数}]}
      chapteJson: [],
      // 联系人相关通讯录
      telList: [],
      telPageInfo: {
        itemPage: 1,
        pageSize: 6,
        total: 0,
        name: null,
        idNo: null,
        accountNo: null
      },
      showTel: false,
      boxHeight: "1170px",
      listHeight: "",
      // 当前页信息
      currentInfo: { page: 1, url: "" },
      accessoryShow: false,
      timer: null,
      // 第一步：false，第二步：true
      nextstep: false,
      // nextstep: false,
      // 显示价格的弹窗
      priseInfo: { mealInfo: null, money: 0, point: 0, cashierUrl: "" },
      priseVisibleDialog: false,
      // 合同类型 1临时文件 3存储文件
      fileType: 1,
      // 是否有视频签署套餐
      hasVideoPackage: false,
      loading: null,
      dragging: false,
      guideStep: null,
      lastGuide: false,
      // 小地图 拖动相对位移
      deviationSmallMap: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        clientWidth: 0,
        clientHeight: 0
      },
      payDisabled: false,
      // 合同缩放比例
      scaleValue: 100,
      chap: [], //未设签章数组
      signDialog: false, //未设签章弹窗
      department: [], // 部门列表
      signlinktime: "", //签署链接时效
      clearable: false
    };
  },
  created () {
    let v = this.$store.getters.currentAuthUser;
    if (v && v.corpUserId) {
      this.isGroup = true;
      this.activeTabOrganizationName = v.corpName;
      // 集团账户情况下，需判断当前账户所在部门是否设置了审批流
      this.hasApprovalFlow();

      if (this.isGroup) {
        this.getDepartmentList();
      }
    }
    this.getAndSetTime();
  },
  mounted () {
    this.boxHeight = document.body.clientHeight - 60 + "px";
    this.listHeight = document.body.clientHeight - 194 + "px";
    this.contractInfo = {
      applyId: null,
      approveJson: "",
      attatchFileNamesJson: "[]",
      consumMode: 0,
      contractId: "exper_5980C2DEE11D4B28A564196014ABB50B",
      contractName: "系统模板",
      docHash:
        "WZ7T6TaypDK-XeG43M-uLBm3czj9hopW5TEH9GzM8U0OXW5z3GHKtfzLD7iPNJhRQoHPkpJkvD3nmoRI5POAOA",
      ifOrder: false,
      items: 2,
      needCa: 0,
      needPresSign: 1,
      needQifengSign: 1,
      needVideoSign: 0,
      overDate: "",
      returnURL:
        "http://web.junziqian.test:3001/signInfo/signList?signStatus=2",
      saveToDraftBox: 0,
      serverCa: 1,
      sign: "APKOOHe0uNSdVQts-ECRsFbjPS5hzZ4fl8acp9ouYls",
      signatoryJson: "[]",
      ts: "1653466346407"
    };
    this.getContractDetailByNum(1);
    // this.contractInfo.needPresSign = Number(query.needPresSign)
    // this.contractInfo.needQifengSign = Number(query.needQifengSign)
    // this.getTelList();

    // this.queryUserHasVideoPackage();
    this.signatoryJson[0].emailOrPhone =
      this.$store.getters.authUser.mobileMash ||
      this.$store.getters.authUser.emailMask;
    // 第一次加载
    this.getUserInfoBySelectTargetId(
      this.signatoryJson[0].emailOrPhone,
      0,
      true
    );
  },
  computed: {
    filePage () {
      return function (file) {
        if (this.chapteJson.length > 0) {
          let arr = this.chapteJson.filter(
            v => v.targetId === file.fileOperVO.targetId
          );
          return arr.length > 0 ? true : false;
        }
      };
    }
  },
  watch: {
    "contractInfo.consumMode" (val) {
      if (val === 1) {
        this.contractInfo.serverCa = 1;
      }
    },
    accessoryShow (val) {
      clearInterval(this.timer);
      let fileHeight = document.getElementById("accessoryList").clientHeight;
      if (val) {
        let top = -fileHeight;
        this.timer = setInterval(() => {
          if (top === 0) {
            return clearInterval(this.timer);
          }
          top += 1;
          this.$refs.accessory.style.bottom = top + "px";
        }, 5);
      } else {
        let top = 0;
        this.timer = setInterval(() => {
          if (top === -fileHeight) {
            return clearInterval(this.timer);
          }
          top -= 1;
          this.$refs.accessory.style.bottom = top + "px";
        }, 5);
      }
    }
  },
  methods: {
    // 获取文件后缀
    fileSuffix (fileName) {
      let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let namelength = fileName.length; //取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      return filesuffix;
    },
    //获取系统时间，并默认签署链接失效时间为三天后
    getAndSetTime () {
      ApiMethods.SysController.getDate().then(res => {
        if (res.success) {
          let a = res.data;
          a = a.substr(0, a.lastIndexOf(":"));
          a = a.replace(/\-/g, "/");
          let three = new Date(a).getTime() + 3 * 24 * 60 * 60 * 1000;
          let ft = moment(new Date(three)).format("YYYY-MM-DD");
          this.signlinktime = ft;
        }
      });
    },

    pickTime (val) {
      let a = moment(val).format("YYYY-MM-DD");
      this.signlinktime = a;
    },

    // 判断集团账户是否有审批流
    hasApprovalFlow () {
      // 查询发起审批流
      let params = {};
      params.itemPage = 1;
      params.pageSize = 100;
      params.flowType = 0; // 流程类型0审批流程1用章流程
      ApiCorpMethods.CorpAuditContractController.pageFlow(params)
        .then(res => {
          if (res.code === "0") {
            this.approvalFlowList = res.data;
            if (this.approvalFlowList.length > 0) {
              this.hasApplyApproval = true;
            } else {
              this.hasApplyApproval = false;
            }
          } else {
            this.hasApplyApproval = false;
            this.$message.error(res.description || "查询审批流程数据失败");
          }
        })
        .catch(error => {
          this.hasApplyApproval = false;
          this.$message.error(error.description || "查询审批流程数据失败");
        });
    },

    handleChangeApprovalFlow (val) {
      let params = {};
      params.flowId = val;
      ApiCorpMethods.CorpAuditContractController.preFlowInst(params)
        .then(res => {
          if (res.code === "0") {
            // convert form data
            if (res.data) {
              let data = res.data;
              // flow
              if (data.partyList) {
                this.flows = data.partyList;
              }
              this.arrayCopior = [];
              if (data.copyToList) {
                (data.copyToList || []).forEach(i => {
                  i.hideRemove = true;
                  this.arrayCopior.push(i);
                });
              }
              if (data.orderFlag === 1) {
                this.flows.forEach((element, index) => {
                  if (this.flows.length - 1 !== index) {
                    element.hiddenArrow = true;
                  } else {
                    element.hiddenArrow = false;
                  }
                });
              } else {
                this.flows.forEach((element, index) => {
                  element.hiddenArrow = false;
                });
              }
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // 批量签署方 修改签署人类型
    handleSignBatchUserType (signator, index) {
      this.getBatchUserInfoBySelectTargetId(signator.emailOrPhone, index);
    },
    changBatchUserShowNoticePhone (selectIndex) {
      let _showNoticePhone = !this.batchArray[selectIndex].showNoticePhone;
      let text = _showNoticePhone ? "添加" : "删除";
      this.$message(`${text}通知手机号`);
      this.$set(
        this.batchArray[selectIndex],
        `showNoticePhone`,
        _showNoticePhone
      );
      this.$set(this.batchArray[selectIndex], `alertMobile`, null);
    },
    // 批量签署方根据用户从table选择的签署人查询信息
    getBatchUserInfoBySelectTargetId (emailOrPhone, selectIndex) {
      if (selectIndex !== undefined) {
        this.selectIndex = selectIndex;
      }
      // 清空验证信息
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        this.$refs["contractBatchListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }

      if (emailOrPhone) {
        this.tableSignorSelectRowTargetID = emailOrPhone;
      }
      if (!emailOrPhone || !this.tableSignorSelectRowTargetID) {
        return;
      }
      let targetId = this.tableSignorSelectRowTargetID;
      if (happy.mobile.test(targetId) || happy.email.test(targetId)) {
        postFindByEmailOrMphon({targetId}).then(data => {
          if (data.data) {
            this.fillBatchSignorData(data.data);
          } else {
            this.fillBatchSignorData([]);
          }
        });
      } else {
        this.fillBatchSignorData([]);
      }
    },
    // 查询到结果后重新赋值
    fillBatchSignorData (canSelectArray) {
      let signor = undefined;
      this.batchArray.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor = element;
        }
      });
      signor.errorMsg = "";
      this.$set(this.batchArray[this.selectIndex], `errorMsg`, "");
      if (
        this.$refs["contractBatchListTab"] &&
        this.$refs["contractBatchListTab"][this.selectIndex]
      ) {
        setTimeout(() => {
          this.$refs["contractBatchListTab"][this.selectIndex].validateField(
            "emailOrPhone"
          );
        });
      }
      if (canSelectArray.length === 0) {
        signor.signatoryFullName = "";
        signor.signatoryIdentityCard = "";
        signor.IDCard = "";
        signor.BusinessLicenseNo = "";
        signor.childUserName = "";
        signor.signatoryMobile = "";
        // signor.signatoryUserType = 0;

        signor.ischange = 0;
        signor.disabled = "";
        signor.handSign = signor.signatoryUserType === 0 ? 1 : 2;

        if (happy.email.test(signor.emailOrPhone)) {
          signor.isNoticePhone = true;
          if (signor.alertMobile) {
            signor.showNoticePhone = true;
          } else {
            signor.showNoticePhone = false;
          }
        } else {
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.alertMobile = "";
        }
      } else {
        let isEmptySignor = false;
        if (signor.signatoryUserType === 1) {
          canSelectArray = canSelectArray.filter(item => item.userType === 1);
          if (
            mobile.mobile.test(signor.emailOrPhone) &&
            canSelectArray.length === 0
          ) {
            isEmptySignor = true;
            signor.showNoticePhone = false;
            signor.alertMobile = "";
          }
          if (happy.email.test(signor.emailOrPhone)) {
            signor.isNoticePhone = true;
            if (signor.alertMobile) {
              signor.showNoticePhone = true;
            } else {
              signor.showNoticePhone = false;
            }
          }
        } else {
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.alertMobile = "";
          canSelectArray = canSelectArray.filter(item => item.userType === 0);
          if (canSelectArray.length === 0) {
            isEmptySignor = true;
          }
        }
        if (isEmptySignor) {
          signor.signatoryFullName = "";
          signor.signatoryIdentityCard = "";
          signor.IDCard = "";
          signor.BusinessLicenseNo = "";
          signor.childUserName = "";
          signor.signatoryMobile = "";
          // signor.signatoryUserType = 0;

          signor.ischange = 0;
          signor.disabled = "";
          signor.handSign = signor.signatoryUserType === 0 ? 1 : 2;
        } else {
          let current = this.$store.getters.currentAuthUser;
          let corpId = "";
          if (current) {
            corpId = current.corpId;
          }
          // 默认选择第一个
          signor.canSelectArrayIndex = 0;
          canSelectArray.forEach((element, index) => {
            if (element.corpId && element.corpId === corpId) {
              signor.canSelectArrayIndex = index;
              signor.corpUser = true;
            }
          });

          let v = canSelectArray[signor.canSelectArrayIndex];
          signor.signatoryFullName = v.name;
          signor.signatoryIdentityCard = v.businessLicense || v.identityCard;
          signor.IDCard = v.userType === 0 ? v.identityCard : "";
          signor.BusinessLicenseNo = v.userType === 0 ? "" : v.businessLicense;

          signor.childUserName = "";
          signor.signatoryMobile = "";

          // signor.signatoryUserType = v.userType;
          if (signor.signatoryUserType === 1) {
            signor.childUserName = v.corpUser; // corpUser集团账户的值
          } else {
            signor.signatoryMobile = signor.emailOrPhone;
          }
          signor.ischange = 1;
          signor.disabled = "disabled";
          if (signor.corpUser) {
            signor.handSign = 0;
          } else {
            signor.handSign = v.userType === 0 ? 1 : 2;
          }
        }
      }
      this.batchArray.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor.canSelectArray = canSelectArray;
          element = signor;
        }
      });
      this.getIsSaveDisable();
    },
    getIsSaveDisable () {
      let _isSaveDisable1 = false,
        _isSaveDisable2 = false,
        _isSaveDisable = false;
      this.signatoryJson.forEach((element, index) => {
        if (element.errorMsg) {
          _isSaveDisable1 = true;
        }
      });
      this.batchArray.forEach((element, index) => {
        if (element.errorMsg) {
          _isSaveDisable2 = true;
        }
      });
      if (_isSaveDisable1 || _isSaveDisable2) {
        _isSaveDisable = true;
      }
      this.isSaveDisable = _isSaveDisable;
    },
    // 批量签署方添加
    batchAdd () {
      if (this.batchArray.length === 100) {
        this.$message.info("单独签署方上限为100个");
        return;
      }
      this.batchArray.push({
        emailOrPhone: "",
        childUserName: "",
        signatoryMobile: "",

        signatoryFullName: "",
        signatoryIdentityCard: "",
        signatoryUserType: 0,

        authLevel: 11,
        handSign: 0,

        chapteJson: null,
        // 新增集团账户 数组
        canSelectArray: [],
        canSelectArrayIndex: 0,

        IDCard: "",
        BusinessLicenseNo: "",
        ischange: 0,
        notRegister: true,
        disabled: "",
        openUserTab: false,
        isEncrypt: false
      });
    },
    // 批量导入
    batchImport () {
      let importBatchFile = this.$refs["importBatchFile"];
      if (importBatchFile) {
        importBatchFile.value = "";
      }
      if (this.batchArray.length > 0) {
        this.$confirm("导入前将清空当前批量签署方, 是否继续导入", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.batchArray = [];
            if (this.$refs["importBatchFile"]) {
              this.$refs["importBatchFile"].click();
            }
          })
          .catch(() => { });
      } else {
        if (this.$refs["importBatchFile"]) {
          this.$refs["importBatchFile"].click();
        }
      }
    },

    /**
     * 20200521新增功能
     * 签署方名称改变时，更新页面中签章对应的签署方名称
     * @signOwner 签署方一二三，根据signOwner找到对应的签章更新
     * @signatoryFullName 需要更改的签署方名称
     * */
    changeQSNameInQZ (signOwner, signatoryFullName) {
      this.chapteJson.map(item => {
        if (item.signOwner === signOwner) {
          item.qsInfo = signatoryFullName; // 更改显示的签署方姓名
        }
      });
    },
    // 选择通讯录和我的组织里面的人 确认按钮事件
    handleClickSelectSignorOk () {
      if (this.activeTabSigner === "organization") {
        this.tableSignorSelectRow = undefined;
      }

      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }

      // 复制以前的代码 怕报错
      /*********************************** */
      this.showTel = false;
      this.telPageInfo.accountNo = null;
      this.telPageInfo.name = null;
      this.telPageInfo.idNo = null;
      this.telPageInfo.itemPage = 1;
      // return openUserTab to false
      if (this.signatoryJson[this.selectIndex]) {
        this.signatoryJson[
          this.selectIndex
        ].emailOrPhone = this.tableSignorSelectRowTargetID;
        // this.signatoryJson[this.selectIndex].openUserTab = false
      }

      /*********************************** */
      this.getUserInfoBySelectTargetId(
        this.tableSignorSelectRowTargetID,
        this.selectIndex,
        true
      );
    },
    // 根据用户从table选择的签署人查询信息 type 是否改变签署人类型
    getUserInfoBySelectTargetId (emailOrPhone, selectIndex, type = false) {
      if (selectIndex !== undefined) {
        this.selectIndex = selectIndex;
      }

      // 清空验证信息
      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      }

      if (emailOrPhone) {
        this.tableSignorSelectRowTargetID = emailOrPhone;
      }
      if (!emailOrPhone || !this.tableSignorSelectRowTargetID) {
        return;
      }
      let targetId = this.tableSignorSelectRowTargetID;
      if (happy.mobile.test(targetId) || happy.email.test(targetId)) {
        postFindByEmailOrMphon({targetId})
          .then(data => {
            if (data.data) {
              this.fillSignorData(data.data, type);
            } else {
              this.fillSignorData([], type);
            }
          })
          .catch(err => {
            this.$message.error(err.description);
          });
      } else {
        this.fillSignorData([], type);
      }
    },
    // 查询到结果后重新赋值
    fillSignorData (canSelectArray, type) {
      let signor = undefined;
      this.signatoryJson.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor = element;
        }
      });

      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        setTimeout(() => {
          this.$refs["contractListTab"][this.selectIndex].validateField(
            "emailOrPhone"
          );
        });
      }
      signor.errorMsg = "";
      this.$set(this.signatoryJson[this.selectIndex], `errorMsg`, "");

      if (canSelectArray.length === 0) {
        // 按照以前老版本改
        if (this.tableSignorSelectRow) {
          // 有值
          // businessLicense: "155454526254523"	证件号
          // enterpriseName: "15545"	签署方名称
          // mobileOrChild: "13896918730"	联系方式
          let targetId = this.tableSignorSelectRow.mobileOrChild;
          let isPhone = false;
          if (happy.mobile.test(targetId)) {
            isPhone = true;
          }

          signor.signatoryFullName = this.tableSignorSelectRow.enterpriseName;
          signor.signatoryIdentityCard = this.tableSignorSelectRow.businessLicense;
          let userType = isPhone ? 0 : 1;

          signor.IDCard =
            userType === 0 ? this.tableSignorSelectRow.businessLicense : "";
          signor.BusinessLicenseNo =
            userType === 0 ? "" : this.tableSignorSelectRow.businessLicense;

          signor.childUserName = "";
          signor.signatoryMobile = "";
          signor.signatoryUserType = userType;
          if (signor.signatoryUserType === 1) {
            signor.childUserName = targetId;
          } else {
            signor.signatoryMobile = targetId;
          }
          signor.ischange = 1;
          signor.disabled = "disabled";
          signor.handSign = userType === 0 ? 1 : 2;

          // 通讯录选择的时候隐藏清空额外短信通知手机号
          signor.isNoticePhone = false;
          signor.showNoticePhone = false;
          signor.alertMobile = "";
        } else {
          // 没有值
          // 下面这是清空的

          // signatoryFullName: 签署方名称, signatoryIdentityCard: 证件号, childUserName: 企业联系, signatoryMobile: 个人联系

          signor.signatoryFullName = "";
          signor.signatoryIdentityCard = "";
          signor.IDCard = "";
          signor.BusinessLicenseNo = "";
          signor.childUserName = "";
          signor.signatoryMobile = "";
          // signor.signatoryUserType = 0;

          signor.ischange = 0;
          signor.disabled = "";
          signor.handSign = signor.signatoryUserType === 0 ? 1 : 2;
          // findByEmailOrMphone数据请求没有数据的时候，emailOrPhone是邮箱就显示额外短信通知手机号
          if (happy.email.test(signor.emailOrPhone)) {
            signor.isNoticePhone = true;
            if (signor.alertMobile) {
              signor.showNoticePhone = true;
            } else {
              signor.showNoticePhone = false;
            }
          } else {
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.alertMobile = "";
          }
        }
      } else {
        // 是否允许改变签署人类型
        if (type) {
          let current = this.$store.getters.currentAuthUser;
          let corpId = "";
          if (current) {
            corpId = current.corpId;
          }
          // 默认选择第一个
          signor.canSelectArrayIndex = 0;
          canSelectArray.forEach((element, index) => {
            if (element.corpId && element.corpId === corpId) {
              signor.canSelectArrayIndex = index;
              signor.corpUser = true;
            }
          });

          let v = canSelectArray[signor.canSelectArrayIndex];
          signor.signatoryFullName = v.name;
          signor.signatoryIdentityCard = v.businessLicense || v.identityCard;
          signor.IDCard = v.userType === 0 ? v.identityCard : "";
          signor.BusinessLicenseNo = v.userType === 0 ? "" : v.businessLicense;

          signor.childUserName = "";
          signor.signatoryMobile = "";

          signor.signatoryUserType = v.userType;

          if (signor.signatoryUserType === 1) {
            signor.childUserName = v.corpUser;
            canSelectArray = canSelectArray.filter(item => item.userType === 1);
            // emailOrPhone是邮箱就显示额外短信通知手机号
            if (happy.email.test(signor.emailOrPhone)) {
              signor.isNoticePhone = true;
              if (signor.alertMobile) {
                signor.showNoticePhone = true;
              } else {
                signor.showNoticePhone = false;
              }
            } else {
              signor.isNoticePhone = false;
              signor.showNoticePhone = false;
              signor.alertMobile = "";
            }
          } else {
            signor.signatoryMobile = signor.emailOrPhone;
            canSelectArray = canSelectArray.filter(item => item.userType === 0);
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.alertMobile = "";
          }
          // canSelectArray改变需要更新canSelectArrayIndex
          let rindex = canSelectArray.findIndex(
            element => element.corpId && element.corpId === corpId
          );
          signor.canSelectArrayIndex = rindex >= 0 ? rindex : 0; // 没有默认选中第一个

          signor.ischange = 1;
          signor.disabled = "disabled";
          if (signor.corpUser) {
            signor.handSign = 0;
          } else {
            signor.handSign = v.userType === 0 ? 1 : 2;
          }
        } else {
          let isEmptySignor = false;
          if (signor.signatoryUserType === 1) {
            canSelectArray = canSelectArray.filter(item => item.userType === 1);
            if (
              happy.mobile.test(signor.emailOrPhone) &&
              canSelectArray.length === 0
            ) {
              isEmptySignor = true;
              signor.showNoticePhone = false;
              signor.alertMobile = "";
              // //清空清空额外短信通知手机号
              // signor.isNoticePhone = false
              // signor.showNoticePhone = false
              // signor.alertMobile = ''
              //
              // signor.errorMsg = `该手机号已注册，但还未加入公司，请核实`;
              // if (this.$refs['contractListTab'] && this.$refs['contractListTab'][this.selectIndex]) {
              //   setTimeout(() => {
              //     this.$refs['contractListTab'][this.selectIndex].fields[0].validateMessage = '该手机号已注册，但还未加入公司，请核实'
              //     this.$refs['contractListTab'][this.selectIndex].fields[0].validateState = 'error'
              //   })
              // }
            }
            if (happy.email.test(signor.emailOrPhone)) {
              signor.isNoticePhone = true;
              if (signor.alertMobile) {
                signor.showNoticePhone = true;
              } else {
                signor.showNoticePhone = false;
              }
            }
          } else {
            signor.isNoticePhone = false;
            signor.showNoticePhone = false;
            signor.alertMobile = "";
            canSelectArray = canSelectArray.filter(item => item.userType === 0);
            if (canSelectArray.length === 0) {
              isEmptySignor = true;
            }
          }
          if (isEmptySignor) {
            signor.signatoryFullName = "";
            signor.signatoryIdentityCard = "";
            signor.IDCard = "";
            signor.BusinessLicenseNo = "";
            signor.childUserName = "";
            signor.signatoryMobile = "";

            signor.ischange = 0;
            signor.disabled = "";
            signor.handSign = signor.userType === 0 ? 1 : 2;
          } else {
            let current = this.$store.getters.currentAuthUser;
            let corpId = "";
            if (current) {
              corpId = current.corpId;
            }
            // 默认选择第一个
            signor.canSelectArrayIndex = 0;
            canSelectArray.forEach((element, index) => {
              if (element.corpId && element.corpId === corpId) {
                signor.canSelectArrayIndex = index;
                signor.corpUser = true;
              }
            });

            let v = canSelectArray[signor.canSelectArrayIndex];
            signor.signatoryFullName = v.name;
            signor.signatoryIdentityCard = v.businessLicense || v.identityCard;
            signor.IDCard = v.userType === 0 ? v.identityCard : "";
            signor.BusinessLicenseNo =
              v.userType === 0 ? "" : v.businessLicense;

            signor.childUserName = "";
            signor.signatoryMobile = "";
            if (happy.email.test(signor.emailOrPhone)) {
              signor.isNoticePhone = true;
            } else {
              signor.isNoticePhone = false;
              signor.showNoticePhone = false;
              signor.alertMobile = "";
            }
            if (signor.signatoryUserType === 1) {
              signor.childUserName = v.corpUser;
            } else {
              signor.signatoryMobile = signor.emailOrPhone;
            }

            signor.ischange = 1;
            signor.disabled = "disabled";
            if (signor.corpUser) {
              signor.handSign = 0;
            } else {
              signor.handSign = v.userType === 0 ? 1 : 2;
            }
          }
        }
      }

      signor.ManualInput = false; // 重置手动输入
      this.signatoryJson.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor.canSelectArray = canSelectArray;
          element = signor;
        }
      });
      this.getIsSaveDisable();
      this.tableSignorSelectRow = undefined;
      this.changeQSNameInQZ(signor.signOwner, signor.signatoryFullName);
    },
    // 我的组织 选择签署人 点击事件
    handleRowClickMyCorp (row, event, column) {
      if (row) {
        this.tableSignorSelectRowTargetID = row.targetId;
      } else {
        this.tableSignorSelectRowTargetID = "";
      }
    },
    // 我的组织 查询签署人
    clickHandleMyCorpSearch () {
      this.queryToolMyCorp();
    },
    // 查询我的组织 签署人列表
    queryToolMyCorp () {
      this.myCorpModel.loading = true;
      this.tableAuditAndCopySelectRow = undefined;
      // if (!this.myCorpModel.keyword) {
      this.myCorpModel.targetId = this.myCorpModel.keyword;
      ApiCorpMethods.CorpCommonController.listCorpUser(this.myCorpModel)
        .then(res => {
          this.myCorpModel.loading = false;
          if (res.code === "0") {
            this.tableListMyCorp = res.data;
            this.myCorpModel.total = res.total;
            if (res.total === 0) {
              this.myCorpModel.emptyText = "暂无数据";
            }
          } else {
            this.tableListMyCorp = [];
            this.myCorpModel.total = 0;
            this.myCorpModel.emptyText = res.description;
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.myCorpModel.loading = false;
          this.tableListMyCorp = [];
          this.myCorpModel.total = 0;
          this.myCorpModel.emptyText = res.description;
          this.$message.error(err.description);
        });
      // } else {
      // this.myCorpModel.loading = false;
      // this.tableListMyCorp = [];
      // this.myCorpModel.total = 0;
      // this.myCorpModel.emptyText = '请输入组织内部签署方名称或账号';
      // }
    },
    handleSizeChangeQueryToolMyCorp (val) {
      this.myCorpModel.itemPage = 1;
      this.myCorpModel.pageSize = val;
      this.queryToolMyCorp();
    },
    handleCurrentChangeQueryToolMyCorp (val) {
      this.myCorpModel.itemPage = val;
      this.queryToolMyCorp();
    },
    // 查询审批人 抄送人列表
    queryToolAuditAndCopy () {
      this.auditAndCopyModel.loading = true;
      this.tableAuditAndCopySelectRow = undefined;
      if (this.auditAndCopyModel.keyword) {
        this.auditAndCopyModel.targetId = this.auditAndCopyModel.keyword;
        ApiCorpMethods.CorpCommonController.listCorpUser(this.auditAndCopyModel)
          .then(res => {
            this.auditAndCopyModel.loading = false;
            if (res.code === "0") {
              this.tableListAuditAndCopy = res.data;
              this.auditAndCopyModel.total = res.total;
              if (res.total === 0) {
                this.auditAndCopyModel.emptyText = "暂无数据";
              }
            } else {
              this.tableListAuditAndCopy = [];
              this.auditAndCopyModel.total = 0;
              this.auditAndCopyModel.emptyText = res.description;
              this.$message.error(res.description);
            }
          })
          .catch(error => {
            this.auditAndCopyModel.loading = false;
            this.tableListAuditAndCopy = [];
            this.auditAndCopyModel.total = 0;
            this.auditAndCopyModel.emptyText = res.description;
            this.$message.error(err.description);
          });
      } else {
        this.auditAndCopyModel.loading = false;
        this.tableListAuditAndCopy = [];
        this.auditAndCopyModel.total = 0;
        this.auditAndCopyModel.emptyText = "请输入组织内部签署方名称或账号";
      }
    },

    // 查询用户是否有视频签署套餐
    queryUserHasVideoPackage () {
      VideoSign.hasVideoPackage()
        .then(({ data }) => {
          this.hasVideoPackage = data;
        })
        .catch(err => {
          this.hasVideoPackage = false;
        });
    },
    // 取消合同发起或保存
    handleDelSendContract () {
      this.signatoryJson.forEach(t => {
        var entName = t.signatoryFullName;
        if (this.entNameArr.indexOf(entName) !== -1) {
          t.signatoryIdentityCard = "";
        }
      });
      this.entCreditArr = [];
      this.entCreditJson = {};
      this.entNameArr = [];
      this.userIdentityInfoArr = [];
      this.visibleCredit = false;
    },

    // 签章列表整理
    chapteJsonFilter () {
      if (!this.chapteJson || !this.chapteJson.length) {
        // 将签章数据置为null
        this.signatoryJson.forEach(sign => {
          sign.chapteJson = null;
        });

        return (this.chapteJson = []);
      }
      let chaptes = {};
      let chaptePage = {};
      let param = [];
      // 按现在存在的联系人列表对签章列表分类
      this.signatoryJson.forEach(sign => {
        chaptes[sign.signOwner] = this.chapteJson.filter(
          chapte => chapte.signOwner === sign.signOwner
        );
      });
      // 根据上面的分类再按照page分类
      for (let key in chaptes) {
        chaptePage[key] = {};

        chaptes[key].forEach(chapt => {
          let page = "page_" + chapt.page;
          if (!chaptePage[key][page]) {
            chaptePage[key][page] = { page: chapt.page, chaptes: [chapt] };
          } else {
            chaptePage[key][page].chaptes.push(chapt);
          }
        });
      }
      for (let key in chaptePage) {
        param[key] = [];
        for (let key1 in chaptePage[key]) {
          param[key].push(chaptePage[key][key1]);
        }
      }
      // 将签章数据放入联系人列表
      this.signatoryJson.forEach(sign => {
        sign.chapteJson = param[sign.signOwner].length
          ? param[sign.signOwner]
          : null;
      });
    },

    guideApplyCancel () {
      localStorage.setItem("APPLY_GUIDE", "guide");
      let refs = this.$refs;
      switch (this.guideStep) {
        case "step1":
          refs.step1.$el.setAttribute("style", "");
          break;
        case "step2":
          refs.step2[0].$el.setAttribute("style", "");
          break;
        case "step3":
          refs.step3[0].$el.setAttribute("style", "");
          break;
        case "step4":
          refs.step4.setAttribute("style", "");
          break;
        case "step5":
          refs.step5.setAttribute("style", "");
          break;
        default:
      }
      this.guideStep = null;
    },
    guideApply (step) {
      if (!step) return;
      this.guideStep = step;
      this.$nextTick(() => {
        let refs = this.$refs;
        let objSetp, stepRect;
        let guidBox = refs.guideBox;

        switch (step) {
          case "step1":
            objSetp = refs[step].$el;
            if (!objSetp) {
              objSetp = refs[step].$el = document.getElementById(step);
            }
            break;
          case "step2":
            refs.step1.$el.setAttribute("style", "");
            objSetp = refs[step][0].$el;
            break;
          case "step3":
            refs.step2[0].$el.setAttribute("style", "");
            objSetp = refs[step][0].$el;
            break;
          case "step4":
            refs.step3[0].$el.setAttribute("style", "");
            objSetp = refs[step];
            localStorage.setItem("APPLY_GUIDE", "guide");
            break;
          case "step5":
            objSetp = refs[step];
            break;
          default:
            this.guideApplyCancel();
            objSetp = null;
            step = null;
            break;
        }
        stepRect = objSetp.getBoundingClientRect();
        // 解决 getBoundingClientRect x,y兼容性
        let { x, y } = stepRect;
        if (x === undefined || y === undefined) return (this.guideStep = null);
        objSetp.setAttribute("style", "position:relative; z-index: 10000;");
        guidBox.setAttribute(
          "style",
          `width:${stepRect.width + 16}px;height:${stepRect.height +
          6}px;left:${x - 8}px;top:${y - 3}px;`
        );
        if (step === "step4") {
          guidBox.setAttribute(
            "style",
            `width:${stepRect.width + 16}px;height:${stepRect.height +
            6}px;left:${x - 8}px;bottom:0px;`
          );
        }
      });
    },
    // 存储文件的合同文件转换，非上传的临时文件转换
    convertContractToInfo (param) {
      this.loadingStart("正在加载合同信息");
      tempConvertToContract(param)
        .then(({ data }) => {
          this.loadingClose();
          // * 如果用户上传了文件，就走 fileList.length>0 的逻辑。
          if (this.fileList.length > 0) {
            this.contractInfoTemporary = {
              docHash: data.docHash,
              ts: param.ts,
              sign: param.sign,
              items: parseInt(data.items),
              targetId: param.targetId
            };
            this.fileImgName = param.fileName;
          } else {
            this.contractInfo.docHash = data.docHash;
            this.contractInfo.items = parseInt(data.items);
            this.currentInfo = { page: 1, url: "" };
            this.contractInfo.ts = param.ts;
            this.contractInfo.sign = param.sign;
            this.contractInfo.contractId = param.targetId;
          }
          this.getContractDetailByNum(1);
        })
        .catch(err => {
          this.loadingClose();
          console.error("合同文件转换 " + JSON.stringify(err));
        });
    },
    // 输入input合同跳页
    handleContractPageClick () {
      let page = this.goPageNum;
      page = parseFloat(page);
      if (!page) return this.$message.warning("请输入正确的页数");
      if (page < 1 || page > this.contractInfo.items)
        return this.$message.warning("请输入正确的页数");
      this.goPageAndFixed(page);
    },
    //  按页数获取合同，在左侧目录定位当前页，中间合同滚动到顶部从头展示
    goPageAndFixed (page) {
      this.getContractDetailByNum(page);
      this.toCurrentPage(page);
      document.querySelectorAll(".contract-view")[0].scrollTop = 0;
    },
    // 页数跳转，定位到当前展示页,定位左侧图片
    toCurrentPage (val) {
      let dom = document.querySelectorAll(".page-con .list")[val - 1];
      if (dom) {
        document.querySelectorAll(".page-con")[0].scrollTop = dom.offsetTop;
      }
    },
    // 按页数获取合同
    getContractDetailByNum (num) {
      let len = this.fileList.length;
      if (this.contractList[num]) {
        return (this.currentInfo = this.contractList[num]);
      }
      if (len > 0) {
        this.currentInfo = {
          page: num,
          url: convertDetailToShow({
            docHash: this.contractInfoTemporary.docHash,
            ts: this.contractInfoTemporary.ts,
            sign: this.contractInfoTemporary.sign,
            items: this.contractInfoTemporary.items,
            targetId: this.contractInfoTemporary.targetId,
            fileType: 3,
            fix: "png",
            num: num - 1
          })
        };
      } else {
        this.currentInfo = {
          page: num,
          url: convertDetailToShow({
            sign: this.contractInfo.sign,
            ts: this.contractInfo.ts,
            fileType: this.fileType,
            fix: "png",
            targetId: this.contractInfo.contractId,
            num: num - 1,
            docHash: this.contractInfo.docHash
          })
        };
      }

      if (!this.contractList[num]) {
        this.contractList[num] = this.currentInfo;
      }
    },
    // 删除签署方
    delSignList: function (sign) {
      if (sign.signOwner === "批量签署方") {
        this.checkedBatch = false;
      }
      // if (sign.signOwner === '甲方') return;

      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].signOwner === sign.signOwner) {
          signerDataList[i].ischecked = false;
        }
      }

      this.signatoryJson = this.signatoryJson.filter(
        t => t.signOwner !== sign.signOwner
      );
      this.delChapterBySignOwner(sign.signOwner);
    },
    // 根据signOwner删除签章列表
    delChapterBySignOwner (signOwner) {
      if (!this.chapteJson.length) return;
      this.chapteJson = this.chapteJson.filter(t => t.signOwner !== signOwner);
      this.listChapteJsonCindex();
    },
    changeSmallMap (val) {
      this.deviationSmallMap = val;
    },
    // 限制签章个数30个
    limitSignCount (signOwner) {
      let v = 0;
      for (let index = 0; index < this.chapteJson.length; index++) {
        const element = this.chapteJson[index];
        if (element.signOwner === signOwner) {
          v++;
        }
      }
      return v;
    },
    /**
     * 20200521新增拖动功能需求
     * 添加签章-拖动
     * @signOwner 签署方一二三
     * @qsInfo 签署方的信息
     * */
    dragQZEnd (ev, signOwner, qsInfo) {
      console.log(
        'this.$el.querySelector(".cont-box").getBoundingClientRect()',
        this.$el.querySelector(".cont-box").getBoundingClientRect()
      );
      let {
        top: contBoxTop,
        left: contBoxLeft,
        width: contBoxW,
        height: contBoxH
      } = this.$el.querySelector(".cont-box").getBoundingClientRect();
      let caechetW = this.$refs["contractView"].scaleToVal(110); // 签章宽高-签章更改这里也需要更改
      let caechetH = this.$refs["contractView"].scaleToVal(110); // 签章宽高-签章更改这里也需要更改
      let delBtnHeight = 7; // 删除按钮超出部分高度-签章更改这里也需要更改
      let sx = ev.pageX || ev.screenX;
      // 兼容火狐浏览器无法获取pageY的问题，这里用screenY-浏览器工具栏高度
      let sy =
        ev.pageY || ev.screenY - (window.outerHeight - window.innerHeight);
      let left = sx - contBoxLeft - caechetW / 2; // 鼠标距离合同左侧距离-二分之一签章宽度
      let top = sy - contBoxTop + caechetH / 2; // 鼠标距离合同顶部距离+二分之一签章高度

      let boundaryValue = this.$refs["contractView"].scaleToVal(35); // 合同的最小边界值
      // 当前文件targetId
      const targetId = this.contractInfoTemporary.targetId;
      console.error("top" + top, "left" + left, boundaryValue);
      if (top < 120) {
        top = 111 + boundaryValue;
      }
      if (top > contBoxH - caechetH - boundaryValue) {
        top = contBoxH - caechetH - boundaryValue;
      }

      if (left < boundaryValue) {
        left = boundaryValue;
      }
      if (left > contBoxW - caechetW - boundaryValue) {
        left = contBoxW - caechetW - boundaryValue;
      }

      // 获取合同图片的宽高 （用于计算距离的比例）
      // let imgBox = document.querySelector('.cont-box>img');
      // let imgWidth = imgBox.naturalWidth || imgBox.width;
      // let imgHeight = imgBox.naturalHeight || imgBox.height;
      let imgWidth = this.deviationSmallMap.width;
      let imgHeight = this.deviationSmallMap.height;

      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].signOwner === signOwner) {
          let url = signerDataList[i].url;
          let len = this.chapteJson.length;
          let v = this.limitSignCount(signOwner);
          if (v >= 30) {
            this.$message({
              message: "温馨提示, 签章最大限制30个!",
              type: "warning"
            });
            return;
          }

          console.log("缩放值:", left, top);
          left = this.$refs["contractView"].scaleToShow(left);
          top = this.$refs["contractView"].scaleToShow(top);
          caechetW = this.$refs["contractView"].scaleToShow(caechetW);
          caechetH = this.$refs["contractView"].scaleToShow(caechetH);

          console.log("真实值", left, top);
          console.log(
            left,
            imgWidth,
            parseFloat((parseInt(left) / imgWidth).toFixed(4))
          );
          let sign = {
            offsetX: parseFloat((left / imgWidth).toFixed(4)), // 统一使用真实值计算
            offsetY: parseFloat((top / imgHeight).toFixed(4)),
            cindex: len,
            signOwner: signOwner,
            qsInfo: qsInfo, // 新需求，需要在签章上显示签署方的信息(辅助变量，不需要传到后端)
            url,
            page: this.currentInfo.page - 1,
            imageHeight: caechetH
          };
          if (this.fileList.length > 0) sign.targetId = targetId;
          this.chapteJson.push(sign);

          console.log("添加签章成功：", this.chapteJson, 6666);
          return this.listChapteJsonCindex();
        }
      }
    },

    /** 添加签章
     * @signOwner 签署方一二三
     * @qsInfo 签署方的信息
     * */
    handleAddChapter (signOwner, qsInfo) {
      const targetId = this.contractInfoTemporary.targetId;
      for (let i = 0; i < signerDataList.length; i++) {
        if (signerDataList[i].signOwner === signOwner) {
          let url = signerDataList[i].url;
          let len = this.chapteJson.length;
          let v = this.limitSignCount(signOwner);
          if (v >= 30) {
            this.$message({
              message: "温馨提示, 签章最大限制30个!",
              type: "warning"
            });
            return;
          }
          this.computeSignImageSize(url, image => {
            let {
              x,
              y,
              imageHeight,
              isNotPy
            } = this.computeClientCenterPosition(image);
            this.chapteJson.push({
              // offsetX: !isNotPy? x + 0.03 * this.chapteJson.length : x, // 合同放大不偏移
              // offsetY: !isNotPy? y + 0.03 * this.chapteJson.length : y, // 合同放大不偏移
              offsetX: x + 0.03 * this.chapteJson.length, // 合同放大不偏移
              offsetY: y + 0.03 * this.chapteJson.length, // 合同放大不偏移
              cindex: len,
              signOwner: signOwner,
              qsInfo: qsInfo, // 新需求，需要在签章上显示签署方的信息(辅助变量，不需要传到后端)
              url: url,
              page: this.currentInfo.page - 1,
              imageHeight: imageHeight,
              targetId
            });
            return this.listChapteJsonCindex();
          });
        }
      }
    },
    // 获取签章图片宽高
    computeSignImageSize (url, callback) {
      let image = new Image();
      image.src = url;
      image.onload = () => {
        callback(image);
      };
    },
    // 计算可视区中心位置
    computeClientCenterPosition (image) {
      let imageWidth = 0,
        imageHeight = 0;
      if (image) {
        // imageWidth = image.width || image.clientWidth || image.naturalWidth; // 之前的章
        // imageHeight = image.height || image.clientHeight || image.naturalHeight; // 之前的章
        imageWidth = 110; // 改版后的章
        imageHeight = 110; // 改版后的章
      }
      // 可视区宽高
      // 加入缩放因子计算
      let fx;
      let fy;
      let isNotPy = false;
      let scaleToShow = this.$refs["contractView"].scaleToShow;
      let scaleToVal = this.$refs["contractView"].scaleToVal;
      let domView = this.$refs["contractView"].$el;
      // console.log(this.deviationSmallMap,[domView])
      if (scaleToVal(this.deviationSmallMap.width) <= domView.clientWidth) {
        // 能显示完全时
        let left = (this.deviationSmallMap.clientWidth - imageWidth) / 2;
        let top = (this.deviationSmallMap.clientHeight - imageHeight) / 2;
        fx = this.deviationSmallMap.left + left;
        fy = this.deviationSmallMap.top + top + imageHeight;
      } else {
        // 不显示完全时
        isNotPy = true; // 放大时不偏移，不然找不到位置
        let marinLeft = 0; // 左侧间隙值
        if (domView.clientWidth > this.deviationSmallMap.width) {
          marinLeft = domView.clientWidth - this.deviationSmallMap.width;
        }
        // 缩放后滚动距离加上可视区域一半的距离（这里的值都是缩放后的值）
        let scrollLeft =
          domView.scrollLeft +
          (domView.clientWidth - scaleToVal(imageWidth)) / 2 -
          scaleToVal(marinLeft / 2);
        // 缩放后滚动距离加上可视区域一半的距离（这里的值都是缩放后的值）
        let scrollTop =
          domView.scrollTop +
          (domView.clientHeight - scaleToVal(imageHeight)) / 2;

        fx = scrollLeft; // 缩放后的值
        fy = scrollTop + scaleToVal(imageHeight); // 缩放后的值
        fx = scaleToShow(fx); // 真实值
        fy = scaleToShow(fy); // 真实值
      }

      return {
        x: parseFloat((fx / this.deviationSmallMap.width).toFixed(2)),
        y: parseFloat((fy / this.deviationSmallMap.height).toFixed(2)),
        imageHeight: imageHeight,
        isNotPy // 新增变量，是否在原有位置偏移（只有合同放大时才不偏移）
      };
    },
    // 根据cindex删除签章
    delChapteByCindex (cindex) {
      if (!this.chapteJson.length) return;

      this.chapteJson = this.chapteJson.filter(t => t.cindex != cindex);
      this.listChapteJsonCindex();
    },
    // 给签章列表添加cindex
    listChapteJsonCindex () {
      if (!this.chapteJson.length) return;
      for (let i = 0; i < this.chapteJson.length; i++) {
        this.chapteJson[i].cindex = i;
      }
    },
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 新增多文件上传
    async fileOnBeforeUpload (file) {
      this.checkAct = -1;
      if (this.fileList.length >= 30) {
        return this.$message.error("当前可上传的文件不能超过30个！");
      }
      const re = new RegExp("(.jpg|.pdf|.doc|.docx|.xls|.xlsx|.wps)$", "i");
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!re.test(file.name)) {
        return this.$message.error(
          "文件格式只能是jpg/png/bmp/pdf/doc/docx/xls/xlsx/wps的文件"
        );
      }
      if (!isLt20M) {
        return this.$message.error("上传文件大小不能超过 20MB!");
      }
      this.loadingStart("文件上传中~");
      uploadFileAndConvertInfo({ file: file, fileType: 1, fileName: file.name })
        .then(data => {
          const resInfo = {
            fileName: data.fileName,
            name: data.fileName,
            fileOperVO: {
              docHash: data.docHash,
              extendsLocation: "",
              fileName: data.fileName,
              fileSize: data.file.size,
              fileType: 3,
              sign: data.tempFile.sign,
              targetId: data.tempFile.targetId,
              targetIdForPreview: "",
              ts: data.tempFile.ts
            },
            tempFile: data.tempFile,
            fileType: 1,
            items: data.items,
            sort: null
          };
          // 清空签章
          this.chapteJson = [];
          this.fileList = [resInfo];
          if (this.contractInfo.contractName === "") {
            let str = this.fileList[0].fileName;
            let index = str.lastIndexOf(".");
            str = str.substring(0, index);
            this.contractInfo.contractName = str;
          }
          // 默认选中第一个文件
          this.chooseFile(resInfo, 0);
          this.loadingClose();
        })
        .catch(err => {
          this.loadingClose();
          this.$message.warning(err.description || "上传文件失败");
        });
    },
    // 选取文件超过数量提示
    fileHandleExceed (files, fileList) {
      let num = files.length + fileList.length;
      if (num > 30) {
        return this.$message.error(
          `当前限制选择 30 个文件，本次选择了 ${files.length
          } 个文件，共选择了 ${files.length + fileList.length} 个文件`
        );
      }
    },
    fileOnError (err) {
      console.log(err);
      this.loadingClose();
    },
    // 切换文件展示合同
    chooseFile (file, i) {
      if (this.checkAct === i) return;
      this.contractList = {};
      this.convertContractToInfo(file.fileOperVO);
      this.checkAct = i;
    }
  },
  components: {
    ContractViewFile,
    ContractView,
    ToolTip,
    SingerForm,
    draggable,
    Flow,
    SignInfoTipsDialog
  },
  head: { title: "文件发起签署" },
  name: "toCreate",
  layout: "fullpage"
};

const signerDataList = [
  {
    signOwner: "签署方一",
    ischecked: true,
    url: "/images/signature/add-sign_a.png"
  },
  {
    signOwner: "签署方二",
    ischecked: false,
    url: "/images/signature/add-sign_b.png"
  },
  {
    signOwner: "签署方三",
    ischecked: false,
    url: "/images/signature/add-sign_c.png"
  },
  {
    signOwner: "签署方四",
    ischecked: false,
    url: "/images/signature/add-sign_d.png"
  },
  {
    signOwner: "签署方五",
    ischecked: false,
    url: "/images/signature/add-sign_e.png"
  },
  {
    signOwner: "签署方六",
    ischecked: false,
    url: "/images/signature/add-sign_f.png"
  },
  {
    signOwner: "签署方七",
    ischecked: false,
    url: "/images/signature/add-sign_g.png"
  },
  {
    signOwner: "签署方八",
    ischecked: false,
    url: "/images/signature/add-sign_h.png"
  },
  {
    signOwner: "签署方九",
    ischecked: false,
    url: "/images/signature/add-sign_i.png"
  },
  {
    signOwner: "签署方十",
    ischecked: false,
    url: "/images/signature/add-sign_j.png"
  },
  {
    signOwner: "批量签署方",
    ischecked: false,
    url: "/images/signature/add-sign_batch.png"
  }
];
</script>
<style>
.el-dialog {
  margin-top: 50px !important;
}

.el-dialog__body {
  padding-top: 0;
}
</style>

<style scoped>
.el-button:hover {
  color: #ffffff !important;
}
.to-create >>> .el-tabs__header {
  margin-bottom: 0;
}

.prise-dialog >>> .el-dialog {
  margin-top: 10% !important;
}

/***
    自定义select样式
  **/
.pay-type {
  padding: 0 15px;
  border: 0px;
  text-align: left;
}

.pay-type:hover {
  background: transparent;
}

.pay-type .custom-transform-rotateZ-180 {
  webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(180deg);
  transform: rotateZ(180deg);
}

.pay-type .custom-transform-rotateZ-0 {
  webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
  -webkit-transform: rotateZ(0deg);
  transform: rotateZ(0deg);
}
</style>

<style lang="less" scoped>
.more-set {
  cursor: pointer;
  font-size: 14px;
  color: #999;
}

.apply-guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 450;
  background: rgba(0, 0, 0, 0.7);

  .tooltiop-btns {
    text-align: right;

    a {
      display: inline-block;
      line-height: 1.7;
      padding: 0 10px;
      color: #ffffff;
      border-radius: 3px;

      &:nth-child(2) {
        color: #333333;
        background: #f5f5f5;
      }
    }
  }

  .tooltip-text {
    margin-bottom: 10px;

    span {
      display: inline-block;
      line-height: 20px;
      width: 20px;
      text-align: center;
      background: #ffffff;
      color: #000000;
      border-radius: 50%;
      margin-right: 7px;
    }
  }

  .tooltip-arrow {
    border: 5px solid transparent;
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -5px;
  }

  .tooltip-top {
    bottom: 55px;

    .tooltip-arrow {
      bottom: -10px;
      border-top-color: #009999;
    }
  }

  .tooltip-bottom {
    top: 50px;
    right: 10px;

    .tooltip-arrow {
      top: -10px;
      border-bottom-color: #009999;
    }
  }

  .tooltip {
    position: absolute;
    min-width: 200px;
    max-width: 300px;
    background: #009899;
    color: #ffffff;
    border-radius: 3px;
    padding: 20px;
  }

  .box {
    position: absolute;
    background: #ffffff;
    border-radius: 3px;
  }
}

/******* 消费弹窗 ********/
.prise-dialog {
  .footer-btn {
    width: 180px;
    margin-top: 10px;
  }

  .box-dashed {
    border-radius: 4px;
    border: 1px dashed #fce2e2;

    img {
      height: 108px;
    }

    h4 {
      font-size: 18px;
      font-weight: 500;
      margin: 10px 0;
    }
  }
}

@keyframes keyRotateToToDown {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(45deg);
  }
  50% {
    transform: rotate(90deg);
  }
  75% {
    transform: rotate(135deg);
  }
  100% {
    transform: rotate(180deg);
  }
}

@keyframes keyRotateToUp {
  0% {
    transform: rotate(180deg);
  }
  25% {
    transform: rotate(225deg);
  }
  50% {
    transform: rotate(270deg);
  }
  75% {
    transform: rotate(315deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.cont-info-form {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 0;

  .tab {
    .list-box {
      padding: 10px 0;

      .i-drag:hover {
        background-color: #f8f8f8;
      }

      .i-drag:active {
        background-color: #fff2e6 !important;
      }

      .draging {
        background-color: #fff2e6;
      }

      .user-type {
        text-align: center;
        /*cursor: pointer;*/
        padding: 0 10px;

        p {
          text-align: center;
          line-height: 50px;
          white-space: nowrap;
          text-overflow: ellipsis;
          box-sizing: border-box;
        }

        i {
          display: inline-block;
          width: 34px;
          height: 32px;
          vertical-align: super;
        }
      }

      .item {
        /*border: 1px solid #fce7e7;*/
        /*margin: 15px;*/
        display: table;
        width: 100%;
        /*width: calc(100% - 30px);*/

        .col {
          /*overflow-x: hidden;*/
          white-space: nowrap;
          text-overflow: ellipsis;
          box-sizing: border-box;
          display: table-cell;
          /*padding-top:8px;*/
          margin-right: 18px;
          /*padding: 8px 20px 0 0;*/

          &:last-child {
            margin-right: 0;
            padding-right: 15px;
          }
        }
      }

      .icon-move_box {
        position: absolute;
        left: -5px;
        width: 15px;
        height: 15px;
        top: 50%;
        margin-top: -8px;
      }

      .icon-move_box i {
        background: url("../../assets/images/move-icon-default.png") no-repeat
          center center;
        background-size: 100% 100%;
        width: 100%;
        height: 100%;
        display: block;
        color: #ec1c1c;
        text-align: center;
        font-size: 20px;
      }

      .icon-move_box i:hover {
        cursor: move;
        background: url("../../assets/images/move-icon.png") no-repeat center
          center;
        background-size: 100% 100%;
      }

      li {
        margin: 10px 0 10px 10px;
        border-radius: 2px;
      }

      .col {
        display: inline-block !important;
      }
    }

    .radio {
      padding: 5px 14px;
      border-bottom: 1px dashed #dbdbdb;

      small {
        color: #999999;
        margin-left: 14px;
      }
    }
  }

  .cont-form {
    width: 100%;

    .amend-tab__form {
      display: inline-block;
      position: absolute;
      width: 30px;
      right: 0;
    }

    .el-radio.is-bordered.is-checked {
      border-color: #ec1c1c;
      color: #333333;
    }

    .checkbox {
      width: 100%;
      height: 80px;
      padding-top: 22px;

      &.end-time {
        box-sizing: border-box;
        width: 100%;
        height: 80px;
        padding: 10px;
        border: 1px solid #dcdfe6;
      }

      p.small {
        padding-left: 0px;
      }

      p.title {
        font-size: 12px;
        color: #666666 !important;
        font-weight: 600;

        i {
          box-sizing: border-box;
          color: #ec1c1c;
        }
      }

      p {
        color: #333333 !important;
        display: inline-block;
      }
    }

    div.h4,
    h4 {
      padding-top: 10px;
      line-height: 36px;
      font-size: 16px;
      margin: 0;
      font-weight: bold;
      border-bottom: 1px solid #f2f2f2;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      /*padding-left:15px;*/

      > i {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: rgba(38, 38, 38, 1);
        opacity: 1;
        border-radius: 100px;
        margin-right: 10px;
        vertical-align: middle;
      }

      .more-set {
        line-height: 32px;
        font-size: 14px;
        margin-right: 20px;
        cursor: pointer;

        i {
          font-size: 26px;
          vertical-align: middle;
        }

        &.down i {
          animation: keyRotateToToDown 0.3s;
          transform: rotate(180deg);
        }

        &.up i {
          animation: keyRotateToUp 0.3s;
          transform: rotate(0deg);
        }

        &.down-noani i {
          transform: rotate(180deg);
        }

        &.up-noani i {
          transform: rotate(0deg);
        }
      }
    }

    /*20200526重置样式*/

    /deep/ .el-input__inner {
      height: 35px;
      line-height: 35px;
      padding-left: 10px;
    }

    .f-top {
      background-color: #ffffff;
      margin-bottom: 20px;

      .el-form-item {
        margin-bottom: 0;
      }

      .el-row {
        padding: 20px 30px 20px 20px;
      }
    }

    .f-center {
      .f-top();

      div.h4 {
        justify-content: space-between;
        flex-wrap: nowrap;

        .el-checkbox__label {
          /*color: #000000;*/
          font-weight: normal;

          b {
            font-weight: normal;
            /*color: #000000;*/
          }
        }

        small {
          color: rgba(0, 0, 0, 0.45);
          margin-left: 5px;
        }

        .more-set {
          color: rgba(0, 0, 0, 0.45);
        }
      }

      .wp {
        flex: auto;
        margin-left: 40px;
      }

      .radio {
        padding: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: nowrap;
      }

      li .el-row {
        padding: 0;
      }
    }

    .f-center2 {
      .f-top();
    }

    .f-bottom {
      .f-top();
      margin-bottom: 100px;
    }

    .bow {
      padding: 20px;
    }

    .sign-item {
      display: flex !important;
      justify-content: space-between;
      align-items: center;
      position: relative;

      > div {
        /*flex: none;*/

        &:last-child {
          flex: auto;
          text-align: right;
        }
      }
    }

    .c-btn {
      min-width: 82px;
      line-height: 25px;
      padding: 0;
      font-size: 12px;
      text-align: center;
      border: 1px solid rgba(236, 28, 28, 1);
      border-radius: 2px;
      color: #ec1c1c;

      &:hover {
        background-color: gba(236, 28, 28, 1);
        color: #ffffff;
      }
    }

    .y-btn {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      border: none;
      padding: 0;
      color: #ec1c1c;
      background: transparent !important;

      &:hover {
        opacity: 0.5;
      }
    }
  }
}

.main-content {
  position: relative;
  display: table-cell;
  box-sizing: border-box;
  vertical-align: top;
  padding: 0;
  /*background: #ffffff;*/
  overflow: hidden;

  .accessory-box {
    position: absolute;
    bottom: 35px;
    width: 100%;
    pointer-events: none;

    .accessory-list {
      pointer-events: initial;
      position: relative;
      width: 100%;
      box-sizing: border-box;
      // border-top: 1px solid rgba(0,0,0,0.16);
      padding: 56px 15px 20px 15px;
      background: #ffffff;
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);

      .accessory-group {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;

        p.list-item {
          display: inline-block;
          position: relative;
          margin: 4px 25px 4px 0;
          padding: 6px 19px 6px 5px;
          // border: 4px;
          font-size: 12px;
          color: #000000;
          background: rgba(248, 248, 248, 1);

          > span {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 200px;
          }
        }

        i.del {
          color: #a1a1a1;
          position: absolute;
          right: -6px;
          top: -6px;
          font-size: 16px;
          cursor: pointer;
        }
      }

      .upload-accessory {
        /*width: 75px;*/
        overflow: hidden;
        position: relative;
        cursor: pointer;
        display: inline-block;

        &:hover {
          opacity: 0.5;
        }

        a {
          // font-size:16px;
          display: inline-block;
          width: 120px;
          line-height: 35px;
          color: #ec1c1c;
          font-weight: bold;
        }

        &:hover a {
          font-weight: 800;
        }
        .up-icon {
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-right: 5px;
        }

        .div-upload {
          /*cursor: pointer;*/
          border: 1px dashed #ec1c1c;
          width: 80px;
          height: 30px;
          line-height: 30px;
          display: inline-block;
          text-align: center;
          color: #ec1c1c;
          font-size: 18px;
          font-weight: normal;
          position: relative;
          z-index: 2;
        }

        .input-upload {
          cursor: pointer;
          position: absolute;
          z-index: 3;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          opacity: 0;
        }
      }
    }

    div.btn {
      pointer-events: initial;
      display: inline-block;
      // width: 120px;
      // height: 35px;
      // line-height: 35px;
      padding: 0 10px;
      font-size: 14px;
      // color: #ffffff;
      // background: #a2a5ac;
      // border-radius: 3px 3px 0 0;
      cursor: pointer;
      width: 150px;
      height: 45px;
      line-height: 45px;
      background: rgba(255, 255, 255, 0.65);
      box-shadow: 0px -2px 12px rgba(0, 0, 0, 0.16);
      border-radius: 6px 6px 0px 0px;
      color: #ec1c1c;
      font-size: 15px;
      font-weight: bold;

      .arrow {
        margin-left: 15px;
        font-size: 12px;
        font-weight: bold;
        vertical-align: middle;
        display: inline-block;
        margin-top: -2px;
      }
    }
  }
}

@mg: 0.2rem; // 左右side给中间合同流的间距
.aside-right {
  box-sizing: border-box;
  // padding: 20px 20px 0 20px;
  background-color: #fafafa;
  overflow: hidden;
  position: relative;
  box-shadow: -0.02rem 0px 0.16rem rgba(0, 0, 0, 0.12);
  /*z-index:3;*/
  margin-left: @mg;

  .list-signers {
    // position: absolute;
    // bottom: 1.2rem;
    // top: 1.8rem;
    overflow-x: hidden;
    overflow-y: auto;
    // position: absolute;
    // width: 160px;
    width: 100%;
    // right: 0;
    padding-bottom: 1.2rem;
    background-color: #ffffff;
    padding-top: 0.25rem;
    // box-shadow: 0.03rem 0px 0.12rem rgba(0, 0, 0, 0.16);

    .del-signer {
      margin-right: 0.05rem;
      font-size: 0.18rem;
      cursor: pointer;
      color: #a1a1a1;
    }

    .del-signer:hover {
      color: #ec1c1c;
    }

    .btn-left {
      width: 0.32rem;
      height: 0.32rem;
      line-height: 0.32rem;
      padding: 0;
      margin-right: -1px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .qy-wrap {
      box-sizing: border-box;
      padding-left: 0.2rem;
      padding-right: 0.25rem;
    }

    .row-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .dragbox {
        flex: auto;

        button {
          width: 100%;
        }
      }

      button {
        flex: auto;
      }
    }

    .btn-group {
      box-sizing: border-box;
      // margin-top: 0.18rem;
      margin-bottom: 0.18rem;
      // width: 140px;
      width: 100%;
      padding-top: 20px;
      // padding: 20px 0;
      position: relative;
      display: inline-block;

      .user-show {
        position: absolute;
        top: 0;
        line-height: 1;
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;

        span {
          display: inline-block;
          // width: 120px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 2rem;
        }
      }
    }
  }

  .btn {
    width: 100%;
    margin: 0 0 0.14rem 0;
  }

  .qs-wrap {
    padding-top: 0.25rem;
    background: rgba(255, 255, 255, 1);
    /*box-shadow:0px 3px 12px rgba(0,0,0,0.06);*/
    position: relative;
    /*z-index: 5;*/

    /deep/ .el-checkbox__label {
      padding-left: 0.1rem;
      line-height: 0.19rem;
      font-size: 14px;
    }

    /deep/ .el-checkbox {
      margin-right: 0.3rem;
    }
  }

  .qs-box {
    // padding:30px 25px 34px 25px;
    padding: 0.2rem 0 0 0;

    > img {
      height: 0.48rem;
      cursor: pointer;
      /*width: max-content;*/
      margin-left: 0.25rem;
      /*min-width:280px;*/
      width: 2.35rem;

      &:hover {
        cursor: pointer;
        /*cursor: url(/images/icon/cursor.ico),pointer;*/
        opacity: 0.7;
      }
    }
  }

  .t2 {
    color: #000000;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
  }

  .t3 {
    color: rgba(0, 0, 0, 0.85);
    font-weight: normal;
    padding-left: 0.3rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.17rem;
    font-size: 12px;
  }

  .m-title {
    .t2();
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.17rem;
  }

  button {
    height: 0.4rem;
    line-height: 0.4rem;
    font-size: 0.14rem;
  }
  .mybtn {
    position: relative;
    i {
      font-size: 0.18rem;
      vertical-align: middle;
      color: #ffffff;
      margin-right: 10px;
      margin-top: -0.02rem;
    }
  }
}

.aside-left {
  padding-top: 0.2rem;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #ffffff;
  box-shadow: 0.02rem 0.03rem 0.16rem rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 1;
  margin-right: @mg;

  .list {
    position: relative;
    margin: 0 0.3rem 0.2rem 0.3rem;
    cursor: pointer;

    span {
      position: absolute;
      bottom: 0.1rem;
      right: 0;
      display: block;
      /*width: 20px;*/
      /*height: 20px;*/
      width: 0.4rem;
      height: 0.3rem;
      line-height: 0.3rem;
      border-radius: 0.06rem 0px 0px 0px;
      color: #fff;
      background-color: #e3e3e3;
      text-align: center;
    }

    img {
      width: 100%;
      /*max-height: 230px !important;*/
      max-height: 3rem !important;
      box-sizing: border-box;
      margin-bottom: 0.1rem;
      border: 0.02rem solid #e3e3e3;
    }
    .bx {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 15vh;
    }
  }

  .page-total {
    color: #646464;
    font-size: 85%;
    padding: 0 0.3rem 0.2rem 0.3rem;
  }
  // .active img {
  //   border-color: #ec1c1c;
  // }

  // .active span {
  //   background-color: #ec1c1c;
  // }
  .active {
    border: 1px solid #ec1c1c;
  }

  .page-con {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0.9rem;
    top: 0.6rem;
  }
}

.tel-box {
  height: 410px;
  overflow: auto;
}

.dialog-footer {
  overflow: hidden;
  padding: 0 0 10px 0;
  margin-bottom: -9px;
}

.to-create {
  margin: -20px;

  .tel-search {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ec1c1c;
}

// 跳转页面
.go-Page {
  // height:60px;
  // line-height:60px;
  padding: 0.3rem 0;
  width: 100%;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 5;
  background-color: #ffffff;

  > div {
    display: inline-block;

    > div {
      display: flex;
      text-align: center;
      justify-content: space-between;
      align-items: center;
      height: 32px;
      line-height: 28px;
    }
  }

  .bd {
    height: 100%;
    box-sizing: border-box;
    border: 1px solid rgba(183, 183, 183, 1);
    border-style: solid none solid solid;
    display: flex;
    text-align: center;
    justify-content: space-between;
    align-items: center;
    padding-right: 0.05rem;
    border-radius: 0.04rem 0 0 0.04rem;
  }

  a {
    text-decoration: none;
    cursor: pointer;
    box-sizing: border-box;
    width: 0.6rem;
    border-radius: 0px 0.04rem 0.04rem 0.04rem;
    display: block;
    background: #999999;
    border: 1px solid #999999;
    color: rgba(255, 255, 255, 1);
    font-family: PingFang SC;
  }

  /deep/ .el-input {
    /*width: 75px;*/
    width: 1.2rem;
    height: 100%;
  }

  /deep/ .el-input__inner {
    font-size: 0.14rem;
    border: none;
    padding: 0 0 0 0.05rem;
    height: 100%;
    line-height: inherit;
  }
}

// select样式
.el-select-dropdown__item.selected {
  color: #ec1c1c;
  font-weight: normal;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(255, 242, 230, 1);
}

@keyframes ripple {
  0% {
    left: 0;
    top: 0;
    opacity: 0.75;
    width: 0;
    height: 0;
  }
  100% {
    left: -0.23rem;
    top: -0.23rem;
    opacity: 0;
    width: 0.6rem;
    height: 0.6rem;
  }
}

.jumpFirst {
  top: -80px;
  bottom: initial;
  pointer-events: initial;
}
.jumpLast {
  top: -25px;
  bottom: initial;
  pointer-events: initial;
}

/deep/.cont-info-form .cont-form .datep .el-input__inner {
  padding-left: 30px;
}
</style>
<style lang="less">
.tel-box {
  .el-table__row.current-row {
    color: #ec1c1c;
  }
}

body {
  .danger-btn {
    height: 40px;
    line-height: 40px;
    padding-top: 0;
    padding-bottom: 0;
    width: 100%;
    // background-color: #ff0000;
    font-size: 14px;
  }

  // 自定义图标cursor
  .csCursor {
    cursor: pointer;
    /*cursor: url(/images/icon/cursor.ico),pointer;*/
  }

  .normal-btn {
    border: none;
    // background-color: rgba(204, 204, 204, 1);
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 14px;
    font-weight: bold;
    color: #ffffff !important;
    position: relative;
    .csCursor();
    &:focus {
      // background-color: rgba(204, 204, 204, 1);
    }
    &:hover {
      background-color: #ec1c1c;
      .rt {
        background: url(../../assets/images/title-icon-active.png) no-repeat
          center center;
        background-size: 100% 100%;
      }
    }

    .rt {
      font-weight: normal;
      position: absolute;
      display: block;
      background: url(../../assets/images/title-icon.png) no-repeat center
        center;
      background-size: 100% 100%;
      height: 30px;
      line-height: 26px;
      width: 70px;
      top: -8px;
      right: -4px;
      z-index: 2;
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/applySign/toCreateDemo.vue